import * as _ from 'lodash';

export default {
  state: {
    formData: null,
    allPersonaFormData: [],
    personaData: [],
    personaDataSelectComponentValues: [],
    initialFormData: null,
    personaDataAfterCalculate: [],
    editState: null,
    errorInForm: null,
    task: null,
  },
  finalData: {
    id: 0,
    config: '',
    regionId: '',
    currency: 'USD',
    citrixLicenseCost: 0,
    pricingModel: '',
    users: 1000,
    sessionType: '',
    persistence: false,
    workerOS: '',
    vdaMeterId: '',
    alwaysAvailableVDAsPercentage: 100,
    vdaSystemDiskMeterId: '',
    autoscale: false,
    hours: 60,
    windowsVirtualDesktop: true,
    workloadProfileName: 'light',
    iopsPerUser: 3.5,
    kbpsPerUser: 190,
    coresPerUser: '0.15',
    memoryMBPerUser: 150,
    highAvailability: false,
    includeInfrastructure: false,
    includeDomainController: true,
    includeNetScaler: true,
    includeStoreFront: true,
    cloudConnectorMeterId: 'e2-standard-2',
    domainControllerMeterId: 'e2-standard-2',
    netScalerMeterId: 'e2-standard-2',
    storeFrontMeterId: 'e2-standard-2',
    userStorageAmountInGB: 100,
    userDiskMeterId: '',
    userDiskSizeInGB: 128,
    rateOverrideVDA: false,
    vdaVDARatePerHour: '',
    rateOverrideDiskType: false,
    vdaDiskTypeRatePerHour: '',
    rateOverrideCloudConnector: false,
    vdaCloudConnectorRatePerHour: '',
    rateOverrideStoreFront: false,
    vdaStoreFrontRatePerHour: '',
    rateOverrideNetScaler: false,
    vdaNetScalerRatePerHour: '',
    rateOverrideDomainController: false,
    vdaDomainControllerRatePerHour: '',
  },

  setFormData(data) {
    this.state.formData = data;
  },

  createPersona(data) {
    const noOfPersonas = this.state.personaData.length;
    var newPersonaValue = _.cloneDeep(this.finalData);
    const id = !noOfPersonas
      ? 0
      : this.state.personaData[noOfPersonas - 1].id + 1;
    data.forEach(item => {
      newPersonaValue[item.id] = item.value;
      item.error = null;
    });
    data['id'] = id;
    newPersonaValue['id'] = id;
    delete newPersonaValue['advanceparameters'];
    // newPersonaValue['hours'] = Number(
    //   (newPersonaValue['hours'] / 4).toFixed(0)
    // );

    this.state.personaData = [...this.state.personaData, newPersonaValue];

    this.state.allPersonaFormData = [...this.state.allPersonaFormData, data];
    this.clearFormDataAction();
  },

  updatePersona(data) {
    data['id'] = this.state.editState;
    var updatePersonaValue = _.cloneDeep(this.finalData);
    updatePersonaValue.id = this.state.editState;
    data.forEach(item => {
      updatePersonaValue[item.id] = item.value;
      item.error = null;
    });

    // updatePersonaValue['hours'] = Number(
    //   (updatePersonaValue['hours'] / 4).toFixed(0)
    // );
    delete updatePersonaValue['advanceparameters'];
    this.state.personaData = [
      ...this.state.personaData.filter(
        (persona, index) => index !== this.state.editState
      ),
      updatePersonaValue,
    ].sort((a, b) => a.id - b.id);

    this.state.allPersonaFormData = [
      ...this.state.allPersonaFormData.filter(
        persona => persona.id !== this.state.editState
      ),
      data,
    ].sort((a, b) => a.id - b.id);
    this.state.editState = null;
    this.clearFormDataAction();
  },

  editPersona(id, task) {
    this.state.editState = id;
    this.state.task = task;
    this.setFormData(
      this.state.allPersonaFormData.filter((item, index) => index === id)[0]
    );
  },

  deletePersonaAction(id) {
    this.state.personaData = this.state.personaData.filter(
      (item, index) => index !== id
    );
    this.state.allPersonaFormData = this.state.allPersonaFormData.filter(
      (item, index) => index !== id
    );
  },

  clearFormDataAction() {
    this.state.editState = null;
    const fieldsToHide = [
      'iopsPerUser',
      'kbpsPerUser',
      'coresPerUser',
      'memoryMBPerUser',
    ];
    var clearFormData = _.cloneDeep(this.state.formData);
    delete clearFormData['id'];
    for (let item in clearFormData) {
      if (fieldsToHide.includes(clearFormData[item].id)) {
        clearFormData[item].isVisible = false;
      }

      clearFormData[item].error = null;

      clearFormData[item].value = this.state.formData[item].default;
    }
    this.setFormData(clearFormData);
  },
};
